import Vue from 'vue'

export default {
	$http: Vue.prototype.$http,
	$Message: Vue.prototype.$Message,
	$t: Vue.prototype.$t,

	//取得參數
	async get(codes: string | Array<string>) {
		if (typeof codes === 'string') {
			codes = [codes]
		}
		try {
			let response = await this.$http.get('api/Para', { params: { paraCodes: codes } })
			return response.data
		} catch (err) {
			this.$Message.error(this.$t('無法取得{0}', [this.$t('參數')]))
		}
	},
}
